import axios from 'axios';
import withDecrypt from '../../../src/withDecrypt';

async function fetchAPI(query, accessToken) {
  return axios({
    method: 'post',
    url: process.env.NEXT_PUBLIC_API_URL,
    data: {
      query,
    },
    headers: { accesstoken: accessToken },
  })
    .then(resp => withDecrypt(resp.data))
    .catch(err => {
      console.log(err);
    });
}

export default async function _renameScreen(screen_name, screen_desc, code, accessToken) {

  const data = await fetchAPI(
    `
    mutation {
      renameScreen(
        screen_name: "${screen_name}"
        screen_desc: "${screen_desc}"
        code: "${code}"
      ) {
        screen_name
      }
    }
    `, accessToken
  )
  return data
}

